import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import DateTimeRange from "../../../components/common/DateTimeRange";
import { toast } from "react-toastify";
import { url } from "../../../Constant";
import axios from "axios";
import { useAuth } from "../../../Context/AuthProvider";

const CreatePackages = () => {
  const { auth } = useAuth();
  const [loader, setLoader] = useState(false);
  const [errorEnable, setErrorEnable] = useState(false);
  const [descriptionError, setDescriptionError] = useState("");
  // const [errorEnable, setErrorEnable] = useState(false);
  const [extensionError, setExtensionError] = useState("");
  const [lengthError, setLengthError] = useState("");
  const [submittedData, setSubmittedData] = useState({
    name: "",
    description: "",
    no_of_groups: 0,
    no_of_extensions: 0,
    voice_minutes_on_net: "",
    sms_on_net: "",
  });

  useEffect(() => {
    if (auth.role !== "1") {
      window.location.href = "/";
    }
  }, []);

  const handleExtensionsChange = (e) => {
    const extensionsValue = parseInt(e.target.value);
    setSubmittedData({
      ...submittedData,
      no_of_extensions: extensionsValue,
    });

    if (extensionsValue < 7) {
      setExtensionError("Extension must be greater than 6");
    } else {
      setExtensionError("");
    }

    if (extensionsValue < submittedData.no_of_groups) {
      setLengthError("No of groups is greater than extensions");
    } else {
      setLengthError("");
    }
  };

  const handleGroupsChange = (e) => {
    const groupsValue = parseInt(e.target.value);
    setSubmittedData({
      ...submittedData,
      no_of_groups: groupsValue,
    });

    if (groupsValue > submittedData.no_of_extensions) {
      setLengthError("No of groups is greater than extensions");
    } else {
      setLengthError("");
    }
  };

  const createPackage = (e) => {
    e.preventDefault();
    setErrorEnable(true);
    setLoader(true);

    if (
      submittedData.name !== "" &&
      submittedData.description !== "" &&
      submittedData.no_of_groups !== 0 &&
      submittedData.no_of_extensions !== 0 &&
      submittedData.voice_minutes_on_net !== "" &&
      submittedData.sms_on_net !== "" &&
      descriptionError === "" &&
      extensionError === "" &&
      lengthError === ""
    ) {
      axios
        .post(url + "store-package", submittedData, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.data.code !== 400) {
              if (response.data.message === "Package added successfully.") {
                setLoader(false);
                toast.success(response.data.message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setTimeout(() => {
                  window.location.href = "/packages";
                }, 2000);
              }
            } else {
              setLoader(false);
              if (response?.data?.data?.no_of_extensions !== undefined) {
                toast.error(response.data.data.no_of_extensions[0], {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 2000,
                });
              } else if (response?.data?.data?.no_of_groups !== undefined) {
                toast.error(response.data.data.no_of_extensions[0], {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 2000,
                });
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <Link to="/packages">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to VPBX manager</span>
                </Link>
                <h3>CREATE PACKAGE</h3>
                <p>
                  Please enter the details for the new company, add user
                  information, select a master number and package.
                </p>
              </div>
            </div>
          </div>
          <form onSubmit={createPackage}>
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">Package information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Package name</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="Package name"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        name: e.target.value,
                      });
                    }}
                  />
                  {errorEnable && submittedData.name === "" && (
                    <div className="formErrors">Package name is required</div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>No. of extensions</label>
                  <input
                    className="uk-input"
                    type="number"
                    aria-label="Input"
                    placeholder="Extensions"
                    onChange={handleExtensionsChange}
                    value={submittedData.no_of_extensions}
                    // onChange={(e) => {
                    //   setSubmittedData({
                    //     ...submittedData,
                    //     no_of_extensions: e.target.value,
                    //   });
                    //   {
                    //     e.target.value < 7
                    //       ? setExtensionError("Extenson must be greater than 6")
                    //       : setExtensionError("");
                    //   }
                    //   submittedData.no_of_groups !== 0 &&
                    //   e.target.value < submittedData.no_of_groups
                    //     ? setLengthError("No of groups is less than extensions")
                    //     : setLengthError("");
                    // }}
                  />
                  {/* {errorEnable && submittedData.no_of_extensions === 0 && (
                    <div className="formErrors">
                      No of extesnion is required
                    </div>
                  )}
                  {errorEnable &&
                    submittedData.no_of_extensions !== "" &&
                    extensionError !== "" && (
                      <div className="formErrors">{extensionError}</div>
                    )} */}

                  {errorEnable && submittedData.no_of_extensions === 0 && (
                    <div className="formErrors">
                      No of extension is required
                    </div>
                  )}
                  {errorEnable && extensionError !== "" && (
                    <div className="formErrors">{extensionError}</div>
                  )}
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>No. of groups</label>
                  <input
                    className="uk-input"
                    type="number"
                    aria-label="Input"
                    placeholder="Groups"
                    onChange={handleGroupsChange}
                    value={submittedData.no_of_groups}
                    // onChange={(e) => {
                    //   setSubmittedData({
                    //     ...submittedData,
                    //     no_of_groups: e.target.value,
                    //   });
                    //   {
                    //     // submittedData.no_of_extensions !== "" &&
                    //     e.target.value > submittedData.no_of_extensions
                    //       ? setLengthError(
                    //           "No of groups is less than extensions"
                    //         )
                    //       : setLengthError("");
                    //   }
                    // }}
                  />
                  {/* {errorEnable && submittedData.no_of_groups === 0 && (
                    <div className="formErrors">No of groups is required</div>
                  )}
                  {errorEnable && lengthError !== "" && (
                    <div className="formErrors">
                      No of groups is less than extensions
                    </div>
                  )} */}
                  {errorEnable && submittedData.no_of_groups === 0 && (
                    <div className="formErrors">No of groups is required</div>
                  )}
                  {errorEnable && lengthError !== "" && (
                    <div className="formErrors">{lengthError}</div>
                  )}
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Minutes</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="Minutes"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        voice_minutes_on_net: e.target.value,
                      });
                    }}
                  />
                  {errorEnable && submittedData.voice_minutes_on_net === "" && (
                    <div className="formErrors">Minutes is required</div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>SMS</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="SMS"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        sms_on_net: e.target.value,
                      });
                    }}
                  />
                  {errorEnable && submittedData.sms_on_net === "" && (
                    <div className="formErrors">SMS is required</div>
                  )}
                </div>

                <div className="uk-width-1-1@m uk-margin-top">
                  <label>Description</label>
                  <textarea
                    className="uk-textarea"
                    rows="2"
                    placeholder=""
                    aria-label="Textarea"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        description: e.target.value,
                      });
                      {
                        e.target.value.length < 5
                          ? setDescriptionError(
                              "Description must be at least 5 characters long"
                            )
                          : setDescriptionError("");
                      }
                    }}
                  ></textarea>

                  {errorEnable && submittedData.description === "" && (
                    <div className="formErrors">Description is required</div>
                  )}
                  {errorEnable &&
                    submittedData.description !== "" &&
                    descriptionError !== "" && (
                      <div className="formErrors">{descriptionError}</div>
                    )}
                </div>

                <div className="uk-width-1-1@m uk-float-right uk-margin-top">
                  <div className="formActionBtn uk-text-right">
                    <Link to="/packages" className="whiteBtn">
                      Cancel
                    </Link>
                    <button className="pinkBtn" type="submit">
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        " Create Package"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreatePackages;
